import {
    queryTask,
    queryAsyncOrderResultTask,
    getProgress,
    getUpsertPlatformBySupplierOnlineGoodsProcess,
    queryAsyncPayResultTask,
    queryAsyncFastRefundTask,
    queryAfterSaleRefundTaskProgress,
} from '@/services/progress'
import { queryAsyncDownloadResult } from '@/services/opAfterSale'
import { queryTaskUsingGET1 } from '@/services/supplier'
import {
    MANUALLY_PULL_ORDERS,
    BATCH_SHARE_GOODS,
    EXPORT_BREAK_ORDER,
    EXPORT_BREAK_GOODS,
    SUPPLIER_ONLINE_ITEM_IMPORT,
    OP_PAYMENT_DETAILS_EXPORT,
    FAST_REFUND_ASYNC,
    SHOP_GOODS_BATCH_EXPORT_BY_SKU,
    CREATE_ADDRESS_STRATEGY_TASK,
    UPLOAD_SUPPLIER_ADDRESS_TASK,
    AFTER_SALE_ONLY_REFUND_TASK,
    AFTER_SALE_AGREE_RETURN_TASK,
    AFTER_SALE_AGREE_RETURN_REFUND_TASK,
    MATRIX_DAREN_FOLLOW_CONFIRM_TASK,
    OP_AFTER_SALES_ADDRESS_ANALYSIS,
    APPLY_SUPPLIER_AFTERSALE_ADDRESS,
    BATCH_ENABLE_STOCK_SYNC_TASK,
    PROFIT_CALCULATE_TASK,
    UPLOAD_PDF_INVOICE_TASK,
    UPLOAD_EXCEL_INVOICE_TASK,
    BATCH_MODIFY_SPECIAL_PRICE_TASK,
    DAREN_SAMPLE_ORDER_CREATE_TASK,
    DAREN_SAMPLE_ORDER_IMPORT_TASK,
    DAREN_SAMPLE_ORDER_HISTORY_IMPORT_TASK,
} from '@/modules/globals/constants/messageCenter'
import { queryExportData as exportShopGoodsBySku, queryTask1 } from '@/services/goods'
import { getProgress as drpPriceRuleProgress } from '@/services/distribute/drpPriceRule'
import { queryTask as importQueryTask } from '@/services/erpGoodsImport'

import { getTaskProgress } from '@/services/afterSale'
import { getTaskProgress as getTaskProgressStatement } from '@/services/statement'
import { getProgress as getProgressDaren } from '@/services/daren'

export const queryTaskFn = (messageType: string) => {
    if (messageType === PROFIT_CALCULATE_TASK) {
        return queryTask1
    }
    if (messageType === BATCH_ENABLE_STOCK_SYNC_TASK) {
        return queryTaskUsingGET1
    }
    if (messageType === MANUALLY_PULL_ORDERS) {
        return queryAsyncOrderResultTask
    }
    if (messageType === BATCH_SHARE_GOODS) {
        return importQueryTask
    }
    if (messageType === SUPPLIER_ONLINE_ITEM_IMPORT) {
        return getUpsertPlatformBySupplierOnlineGoodsProcess
    }
    if (messageType === OP_PAYMENT_DETAILS_EXPORT) {
        return queryAsyncPayResultTask
    }
    if (messageType === OP_AFTER_SALES_ADDRESS_ANALYSIS) {
        return ({ taskId }) => {
            return new Promise((resolve, reject) => {
                queryAsyncDownloadResult({ taskId })
                    .then(response => {
                        resolve({
                            ...response,
                            data: {
                                ...response.data,
                                taskState: response?.data?.success ? 'end' : 'process',
                            },
                        })
                    })
                    .catch(reject)
            })
        }
    }
    if (
        [
            MATRIX_DAREN_FOLLOW_CONFIRM_TASK,
            DAREN_SAMPLE_ORDER_CREATE_TASK,
            DAREN_SAMPLE_ORDER_IMPORT_TASK,
            DAREN_SAMPLE_ORDER_HISTORY_IMPORT_TASK,
        ].includes(messageType)
    ) {
        return ({ taskId }) => {
            return new Promise((resolve, reject) => {
                getProgressDaren({ taskId })
                    .then(response => {
                        resolve({
                            ...response,
                            data: {
                                ...response.data,
                                taskState: response?.data?.taskState === 'end' ? 'end' : 'process',
                                responseTaskState: response?.data?.taskState,
                            },
                        })
                    })
                    .catch(reject)
            })
        }
    }
    if (messageType === BATCH_MODIFY_SPECIAL_PRICE_TASK) {
        return ({ taskId }) => {
            return new Promise((resolve, reject) => {
                drpPriceRuleProgress({ id: taskId })
                    .then(response => {
                        resolve({
                            ...response,
                            data: {
                                ...response.data,
                                curProcess: response?.data?.percent || 0,
                                taskState: response?.data?.finished ? 'end' : 'process',
                            },
                        })
                    })
                    .catch(reject)
            })
        }
    }
    if (messageType === SHOP_GOODS_BATCH_EXPORT_BY_SKU) {
        return exportShopGoodsBySku
    }
    if (messageType === FAST_REFUND_ASYNC) {
        return queryAsyncFastRefundTask
    }
    if (messageType === EXPORT_BREAK_ORDER || messageType === EXPORT_BREAK_GOODS) {
        return ({ taskId }) => {
            return new Promise((resolve, reject) => {
                getProgress(taskId)
                    .then(response => {
                        resolve({
                            ...response,
                            data: {
                                ...response.data,
                                taskState: response?.data?.finished ? 'end' : 'process',
                            },
                        })
                    })
                    .catch(reject)
            })
        }
    }

    if (
        [AFTER_SALE_ONLY_REFUND_TASK, AFTER_SALE_AGREE_RETURN_TASK, AFTER_SALE_AGREE_RETURN_REFUND_TASK].includes(
            messageType,
        )
    ) {
        return queryAfterSaleRefundTaskProgress
    }
    if (
        [CREATE_ADDRESS_STRATEGY_TASK, UPLOAD_SUPPLIER_ADDRESS_TASK, APPLY_SUPPLIER_AFTERSALE_ADDRESS].includes(
            messageType,
        )
    ) {
        return ({ taskId }) => {
            return new Promise((resolve, reject) => {
                getTaskProgress({ taskId })
                    .then(response => {
                        resolve({
                            ...response,
                            data: {
                                ...response.data,
                                ...(response.data?.result || {}),
                                taskState: response?.data?.curProcess === 100 ? 'end' : 'process',
                            },
                        })
                    })
                    .catch(reject)
            })
        }
    }
    if ([UPLOAD_PDF_INVOICE_TASK, UPLOAD_EXCEL_INVOICE_TASK].includes(messageType)) {
        return ({ taskId }) => {
            return new Promise((resolve, reject) => {
                getTaskProgressStatement({ taskId })
                    .then(response => {
                        resolve({
                            ...response,
                            data: {
                                ...response.data,
                                ...(response.data?.result || {}),
                                taskState: response?.data?.curProcess === 100 ? 'end' : 'process',
                            },
                        })
                    })
                    .catch(reject)
            })
        }
    }

    return queryTask
}
const afterSaleTypeMap: { [key: string]: string } = {
    [AFTER_SALE_ONLY_REFUND_TASK]: '仅退款',
    [AFTER_SALE_AGREE_RETURN_TASK]: '同意退货',
    [AFTER_SALE_AGREE_RETURN_REFUND_TASK]: '退货退款',
}
export const getExtraParams = (messageType: string) => {
    if (
        [AFTER_SALE_ONLY_REFUND_TASK, AFTER_SALE_AGREE_RETURN_TASK, AFTER_SALE_AGREE_RETURN_REFUND_TASK].includes(
            messageType,
        )
    ) {
        return {
            afterSaleType: afterSaleTypeMap[messageType],
        }
    }
    return {}
}
